import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HeaderResponse } from '../../base/interfaces/headerInterface';
import { initialHeaderDetailsState } from '../../store';

export const headerDetailsSlice = createSlice({
  name: 'headerDetails',
  initialState: initialHeaderDetailsState,
  reducers: {
    setHeaderDetails: (state, action: PayloadAction<HeaderResponse>): HeaderResponse => {
      return { ...state, ...action.payload };
    },
  },
});

export default headerDetailsSlice.reducer;
